import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  Rectangle,
  XAxis,
  YAxis,
} from "recharts";

const CustomBarChart = ({ data, width = 500, height = 500 }) => {
  return (
    <BarChart width={width} height={height} data={data}>
      <CartesianGrid strokeDasharray="3 5" strokeWidth={0.5} />
      <XAxis dataKey="name" fontFamily="Poppins, serif" fontSize={"12px"} />
      <YAxis fontFamily="Poppins, serif" fontSize={"12px"} />
      <Bar dataKey="value" activeBar={<Rectangle />} barSize={50} label>
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
        <LabelList
          dataKey="value"
          position="top"
          fontFamily="Poppins, serif"
          fontSize={"12px"}
          fill="#000"
        />
      </Bar>
    </BarChart>
  );
};

export default CustomBarChart;
